<section class="container-fluid we_are_anima">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-8 d-flex justify-content-end">
                <h2>Ми anima</h2>
            </div>
            <div class="col-12 col-md-1">
            </div>
            <div class="col-3">
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-md-8 text d-flex align-items-end mb-5">
                <p class="pad">
                    Аnima сформувалася з Beehiveor - науково-дослідного центру, який заснував Сергій Данилов, Ph.D.,
                    нейрофізіолог. З моменту створення у 2016 році Beehiveor - на провідних позиціях наукових досліджень
                    у галузі нейронаук. Центр накопичив значний обсяг даних та експертиз щодо аналізу поведінки руху
                    очей. Наша основа, яка спирається на ретельні наукові дослідження, дала нам інструменти для
                    розуміння складного зв'язку між рухами очей та психічними станами. І, відповідно, створила платформу
                    для Anima
                </p>
                <p class="pad">
                    Для Beehiveor, як і для всієї України, у лютому 2022 року, коли розпочалась повномасштабна війна, -
                    ситуація змінилася кардинально.
                </p>

                <div class="accent">
                    <p>
                        Beehiveor усвідомив нагальну потребу підтримати психічне здоров’я всіх нас у ці безпрецедентні
                        часи і повністю зосередив свою діяльність на забезпеченні практичних, науково обґрунтованих,
                        дистанційних та безпечних методів перевірки психічних станів.
                    </p>
                </div>
                <p class="pad">
                    Ця зміна фокусу була не просто бізнес-рішенням. Це була відповідь на вторгнення на територію нашої
                    Батьківщини, спосіб використати наш науковий досвід для вирішення нагальних і актуальних потреб.
                    Саме на апогеї кризи та інновацій була сформована Anima, яка втілила наше прагнення до психічного
                    благополуччя через науково обґрунтовані технології.
                </p>
                <p class="pad">
                    Мільйони молодих людей і люди старшого віку раптово опинилися у стані стресу, зустрілися з травмами
                    та страхами, які погіршили їхнє психічне здоров'я. Масштаб війни вразив усіх. Ніхто не знав, як
                    чесно відповісти на таке доволі просте питання "Як справи?". Anima була створена, щоб дати відповідь
                    на нього.
                </p>
                <div class="line"></div>
            </div>
            <div class="col-12 col-md-1 ">
            </div>
            <div class="col-12 col-md-3 sidebar ">
                <div class="share">
                    <app-result-share-links class="mb-4"></app-result-share-links>
                    <ng-container *ngIf="!subscribed; else uns">
                        <input type="email" placeholder="mailto:yourmail@gmail.com"/>
                        <div class="agree">
                            <input type="checkbox" name="checkbox"/>
                            <span>Я згоден з умовами</span>
                        </div>
                        <button class="action hover_action" (click)="subscribe()">
                            <span>Підпишіться</span>
                            <img src="./assets/img/chevron-right.svg" alt="chevron-right">
                        </button>
                    </ng-container>
                    <ng-template #uns>
                        <button class="action hover_action" (click)="unsuscribe()">
                            <span>Відписатися</span>
                            <img src="./assets/img/chevron-right.svg" alt="chevron-right">
                        </button>
                    </ng-template>
                </div>
                <div class="d-flex justify-content-end mb-5">
                    <picture class="main-img">
                        <source media="(max-width: 799px)" srcset="assets/img/mon1_1x.webp"/>
                        <source media="(min-width: 800px)" srcset="assets/img/mon1_2x.webp"/>
                        <img src="assets/img/mon1_2x.webp" alt="anima monitor"/>
                    </picture>
                </div>
                <div></div>
            </div>
        </div>
    </div>
</section>
<section class="container-fluid ">
    <div class="container">
        <div class="row mb-4">
            <div class="col-12 col-md-8 d-flex justify-content-end">
                <h2>Партнери</h2>
            </div>
            <div class="col-12 col-md-1">
            </div>
            <div class="col-12 col-md-3"></div>
        </div>
        <div class="row">
            <div class="col-12 col-md-2"></div>
            <div class="col-12 col-md-7">
                <div class="partners">
                    <div class="partners-item">
                        <div class="logo">
                            <img src="./assets/img/bee.png">

                        </div>
                        <div class="text">
                            <p>центр нейробіологічних досліджень і нейротехнологій, який допомагає вивчати людину.</p>
                        </div>
                    </div>

                    <div class="partners-item">
                        <div class="logo">
                            <img src="./assets/img/ai.png">

                        </div>
                        <div class="text">
                            <p>центр маркетингу та бізнес-консалтингу, який допомагає бізнесу розвиватися.</p>
                        </div>
                    </div>

                    <div class="partners-item">
                        <div class="logo">

                            <img src="./assets/img/vh.png">
                        </div>
                        <div class="text">
                            <p>організація, яка допомагає ветеранам повернутися до цивільного життя після військової служби.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-3"></div>
        </div>
        <div class="row mb-5">
            <div class="col-12 col-md-2">
            </div>
            <div class="col-12 col-md-10">
                <div class="row mb-2">
                    <div class="col-12 col-md-4">
                        <div class="d-flex align-items-end mb-5">
                            <picture>
                                <source media="(max-width: 799px)" srcset="assets/img/danilov_1x.webp"/>
                                <source media="(min-width: 800px)" srcset="assets/img/danilov_2x.webp"/>
                                <img width="110px" src="assets/img/danilov_2x.webp" alt="Serhiy Danilov"/>
                            </picture>
                            <p class="m-0 ml-3">
                                <b>Сергій Даниловv</b><br>
                                <small>Ph.D., нейрофізіолог,<br>
                                    співзасновник платформи Anima.</small>
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-8 border-left quote-text">
                        <svg class="quote-icon" width="43" height="34" viewBox="0 0 43 34" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M25.4 33.1V12.1C25.4 2.3 32.1 -9.53674e-07 35.6 -9.53674e-07H42.8V9H39.2C35.5 9 34.9 11.7 34.9 12.7V16.1H42.8V33.1H25.4ZM0.7 33.1V12.1C0.7 2.3 7.4 -9.53674e-07 10.9 -9.53674e-07H18.1V9H14.5C10.7 9 10.2 11.8 10.2 12.7V16.1H18.1V33.1H0.7Z"
                                  fill="#10082F"/>
                        </svg>
                        Підвищена увага до загрози є прогностичним маркером початку тривожного розладу та депресії. Ми можемо побачити ядро цього процесу, вимірявши рух очей, оскільки окоруховий нерв та функції уваги тісно інтегровані на нейронному рівні.
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-5">
            <div class="col-12 col-md-3">
            </div>
            <div class="col-12 col-md-6 mb-2">
                <p>Anima — це унікальний тест, який допомагає відстежувати, розуміти та визначати свій психічний та емоційний стан, а також те, куди ми спрямовуємо свою увагу. А також це практичні поради, як перефокусуватися за потреби. Лише 10 хвилин вашого часу і Anima оцінить вашу реакцію на емоційні подразники та виміряє схильність до психічних розладів. Наш протокол тестування використовує ай-трекінг для вимірювання викривлення уваги. Така технологія робить цей метод оцінювання одним із найсучасніших і найретельніших. Веб-камера записує рухи очей, щоб виміряти фокус у відповідь на різні подразники. Метод враховує, що тривожність та депресія мають такі спільні риси: підвищена вразливість до стресу, емоційна дисрегуляція та змінене сприйняття винагороди. Ці фундаментальні механізми можуть бути спотвореними або дисфункціональними при обох розладах, що і призводить до спільних симптомів - роздратованості, втоми та порушення сну. Наш підхід допомагає пояснити спільність між симптомами різних захворювань. Anima не є діагностичним інструментом. Ми не зосереджуємось на традиційних діагнозах. Ми прагнемо зрозуміти основні психологічні механізми, зміщуючи фокус з традиційних розладів на механізми, які лежать в основі їх розвитку. Окрім результатів тесту, Anima дає рекомендації для підтримки продуктивності, психічного здоров'я та благополуччя. </p>
            </div>
        </div>
        <div class="row mb-5">
            <div class="col-12 col-md-2">
            </div>
            <div class="col-12 col-md-10">
                <div class="row mb-2">
                    <div class="col-12 col-md-4">
                        <div class="d-flex align-items-end mb-5">
                            <picture>
                                <source media="(max-width: 799px)" srcset="assets/img/havrysh_1x.webp"/>
                                <source media="(min-width: 800px)" srcset="assets/img/havrysh_2x.webp"/>
                                <img width="110px" src="assets/img/havrysh_2x.webp" alt="Roman Havrysh"/>
                            </picture>
                            <p class="m-0 ml-3">
                                <b>Роман Гавриш</b><br>
                                <small>CEO та співзасновник Anima.</small>
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-8 border-left quote-text">
                        <svg class="quote-icon" width="43" height="34" viewBox="0 0 43 34" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M25.4 33.1V12.1C25.4 2.3 32.1 -9.53674e-07 35.6 -9.53674e-07H42.8V9H39.2C35.5 9 34.9 11.7 34.9 12.7V16.1H42.8V33.1H25.4ZM0.7 33.1V12.1C0.7 2.3 7.4 -9.53674e-07 10.9 -9.53674e-07H18.1V9H14.5C10.7 9 10.2 11.8 10.2 12.7V16.1H18.1V33.1H0.7Z"
                                  fill="#10082F"/>
                        </svg>
                        Під час проведення тестів у психіатричних закладах ми на власні очі побачили трансформаційну силу розуміння власного психічного стану. Така проста дія як проходження нашого тесту та отримання результатів давала пацієнтам відчуття чіткості та ясності. Цей досвід підкреслив для нас глибокий вплив знань. Можливість припідняти завісу над внутрішніми механізмами нашої психіки дозволяє нам пізнати своє справжнє “Я”, яким би викликом це не було. Таке самоусвідомлення дає людям змогу вносити необхідні зміни у своє життя, і це те, про що саме Anima
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-5">
            <div class="col-12 col-md-9 d-flex justify-content-end">
                <picture class="main-img">
                    <source media="(max-width: 799px)" srcset="assets/img/prof_1x.webp"/>
                    <source media="(min-width: 800px)" srcset="assets/img/prof_2x.webp"/>
                    <img src="assets/img/prof_2x.webp" alt="anima monitor"/>
                </picture>
            </div>
            <div class="col-12 col-md-3">
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-8 mb-2 d-flex justify-content-end">
                <p class="pad">
                    У Anima цінності є основою нашої місії революціонізувати оцінку психічного здоров'я. Ми незмінно віддані науковій чесності. Наша технологія ай-трекінг і методологія базуються на фактичних даних та проходять строгу перевірку. Водночас наша глибока емпатія та співчуття спонукає нас створити безпечне середовище для психічного благополуччя. Ми надаємо перевагу доступності, адже пропонуємо дистанційні веб-послуги, щоб допомогти людям незалежно від місця їх перебування. Особливо в умовах критичної необхідності. Приватність і безпека - надважливі. Ми використовуємо найсучасніші методи для захисту конфіденційних даних про психічне здоров’я. Ми постійно вдосконалюємось, покращуємо сервіси шляхом безперервних досліджень і розробок. А почуття соціальної відповідальності спонукає нас використовувати наші технології для загального блага.
                </p>
            </div>
            <div class="col-12 col-md-1"></div>
            <div class="col-12 col-md-3">
                <picture>
                    <source media="(max-width: 799px)" srcset="assets/img/mon2_1x.webp"/>
                    <source media="(min-width: 800px)" srcset="assets/img/mon2_2x.webp"/>
                    <img src="assets/img/mon2_2x.webp" alt="anima monitor"/>
                </picture>
            </div>
        </div>
    </div>
</section>
<app-footer></app-footer>
